import { useEffect } from 'react';
import { useEmployeeAuthStore } from '../stores';
import './Employee.css';

function EmployeePortal() {
  const { employee, logout, isAuthenticated, initialize } = useEmployeeAuthStore();

  useEffect(() => {
    // Initialize authentication state on mount
    if (!isAuthenticated) {
      initialize();
    }
  }, [isAuthenticated, initialize]);

  const handleLogout = () => {
    logout();
    window.location.href = '/employee/login';
  };

  if (!isAuthenticated) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Please log in to access your portal.
      </div>
    );
  }

  return (
    <div className="employee-portal-container">
      <header className="employee-portal-header">
        <div className="employee-portal-header-content">
          <h1>Employee Portal</h1>
          <div className="employee-portal-header-actions">
            <span className="employee-portal-welcome">Welcome, {employee?.username || 'Employee'}</span>
            <button onClick={handleLogout} className="employee-portal-logout-btn">
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="employee-portal-content">
        <div className="employee-portal-section">
          <h2>Your Information</h2>
          <div className="employee-portal-info">
            <div className="employee-info-item">
              <label>Username</label>
              <p>{employee?.username || 'N/A'}</p>
            </div>
            <div className="employee-info-item">
              <label>Login Time</label>
              <p>
                {employee?.loginTime 
                  ? new Date(employee.loginTime).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })
                  : 'N/A'}
              </p>
            </div>
          </div>
        </div>

        <div className="employee-portal-section">
          <h2>Your Projects</h2>
          <p>Project information will be displayed here once available.</p>
        </div>
      </div>
    </div>
  );
}

export default EmployeePortal;



